import { FC, useRef } from 'react';

import './style.scss';
import { buildInnerHtml } from '@lemon8/web-app-shared/util';

interface FullArticleBodyProps {
  fullContent: string;
}

export const FullArticleBody: FC<FullArticleBodyProps> = (props) => {
  const { fullContent } = props;
  const fullAnswerRef = useRef<HTMLDivElement>(null);

  return (
    <div className="full-answer-body" ref={fullAnswerRef}>
      <div className="full-answer-body-content" dangerouslySetInnerHTML={buildInnerHtml(fullContent)} />
    </div>
  );
};
